import { Box, Chip, Divider, Stack, Typography } from '@mui/material'

interface Props {
  fieldName: string
  path: string
  oldValue?: string
  newValue?: string
}

interface PillDetail {
  label: string
  color: 'info' | 'warning' | 'error'
}

const getPillDetail = (isCreation: boolean, isDeletion: boolean): PillDetail => {
  if (isCreation) {
    return { label: 'Created', color: 'info' }
  } else if (isDeletion) {
    return { label: 'Deleted', color: 'error' }
  }
  return { label: 'Modified', color: 'warning' }
}

const prettyPrint = (value: string | undefined): string => {
  if (value === undefined) {
    return 'undefined'
  }

  try {
    return JSON.stringify(JSON.parse(value), null, 2)
  } catch {
    return value
  }
}

const ChangeLogItem: React.FC<Props> = ({ fieldName, path, oldValue, newValue }) => {
  const isCreation = oldValue === undefined && newValue !== undefined
  const isDeletion = oldValue !== undefined && newValue === undefined

  const pillDetails = getPillDetail(isCreation, isDeletion)

  return (
    <Stack direction="column">
      <Box padding={1} sx={{ backgroundColor: '#ddd' }}>
        <Stack direction="row" gap={1} alignItems="center">
          <Typography variant="subtitle1">Field: {fieldName}</Typography>
          <Chip
            label={pillDetails.label}
            color={pillDetails.color}
            size="small"
            sx={{ marginLeft: 'auto' }}
          />
        </Stack>
      </Box>
      <Box padding={1} sx={{ backgroundColor: '#efefef' }}>
        <Typography variant="subtitle2">From:</Typography>
      </Box>
      <Box padding={1}>
        <code style={{ whiteSpace: 'pre-wrap' }}>{prettyPrint(oldValue)}</code>
      </Box>
      <Divider />
      <Box padding={1} sx={{ backgroundColor: '#efefef' }}>
        <Typography variant="subtitle2">To:</Typography>
      </Box>
      <Box padding={1}>
        <code style={{ whiteSpace: 'pre-wrap' }}>{prettyPrint(newValue)}</code>
      </Box>
    </Stack>
  )
}

export default ChangeLogItem
